import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import assert from '../utils/assert';
import parseWithWorker from './parse-with-worker';
import { getArrayBufferOrStringFromDataSync, getArrayBufferOrStringFromData, getAsyncIteratorFromData, getIteratorFromData, getUrlFromData } from './loader-utils/get-data';
export function parseWithLoader(_x, _x2, _x3, _x4) {
  return _parseWithLoader.apply(this, arguments);
}

function _parseWithLoader() {
  _parseWithLoader = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(data, loader, options, url) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = url || getUrlFromData(data);
            _context.next = 3;
            return getArrayBufferOrStringFromData(data, loader);

          case 3:
            data = _context.sent;

            if (!(loader.parseTextSync && typeof data === 'string')) {
              _context.next = 7;
              break;
            }

            options.dataType = 'text';
            return _context.abrupt("return", loader.parseTextSync(data, options, url, loader));

          case 7:
            if (!loader.parseSync) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", loader.parseSync(data, options, url, loader));

          case 9:
            if (!loader.parse) {
              _context.next = 13;
              break;
            }

            _context.next = 12;
            return loader.parse(data, options, url, loader);

          case 12:
            return _context.abrupt("return", _context.sent);

          case 13:
            if (!loader.worker) {
              _context.next = 17;
              break;
            }

            _context.next = 16;
            return parseWithWorker(loader.worker, data, options);

          case 16:
            return _context.abrupt("return", _context.sent);

          case 17:
            return _context.abrupt("return", assert(false));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _parseWithLoader.apply(this, arguments);
}

export function parseWithLoaderSync(data, loader, options, url) {
  data = getArrayBufferOrStringFromDataSync(data, loader);

  if (loader.parseTextSync && typeof data === 'string') {
    return loader.parseTextSync(data, options, url, loader);
  }

  if (loader.parseSync) {
    return loader.parseSync(data, options, url, loader);
  }

  return assert(false);
}
export function parseWithLoaderInBatches(_x5, _x6, _x7, _x8) {
  return _parseWithLoaderInBatches.apply(this, arguments);
}

function _parseWithLoaderInBatches() {
  _parseWithLoaderInBatches = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(data, loader, options, url) {
    var inputIterator, outputIterator;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!loader.parseInBatches) {
              _context2.next = 6;
              break;
            }

            _context2.next = 3;
            return getAsyncIteratorFromData(data);

          case 3:
            inputIterator = _context2.sent;
            outputIterator = loader.parseInBatches(inputIterator, options, url, loader);
            return _context2.abrupt("return", outputIterator);

          case 6:
            return _context2.abrupt("return", null);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _parseWithLoaderInBatches.apply(this, arguments);
}

export function parseWithLoaderInBatchesSync(_x9, _x10, _x11, _x12) {
  return _parseWithLoaderInBatchesSync.apply(this, arguments);
}

function _parseWithLoaderInBatchesSync() {
  _parseWithLoaderInBatchesSync = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(data, loader, options, url) {
    var inputIterator, outputIterator;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!loader.parseInBatchesSync) {
              _context3.next = 4;
              break;
            }

            inputIterator = getIteratorFromData(data);
            outputIterator = loader.parseInBatchesSync(inputIterator, options, url, loader, url);
            return _context3.abrupt("return", outputIterator);

          case 4:
            return _context3.abrupt("return", assert(false));

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _parseWithLoaderInBatchesSync.apply(this, arguments);
}